// extracted by css-extract-rspack-plugin
export default {"link":"jSLWR","card":"IE0jb"};